/* Heat product page helpers.
   0. Sitewide sale: show the discounted price worked out from Horizon's (Expo-updated) price.
      Hide a struck-through price that is not above the price being charged (lens upgrades).
   1. The sticky add-to-basket bar shows Horizon's variant price, which misses the Expo lens
      upgrade. Mirror the buy box price (which Expo and variant changes update) into it.
   2. On phones the Shopify Inbox chat button covers the buy buttons and the sticky bar, so hide
      it while either is on screen. */
(function () {
  var sticky = function () { return document.querySelector('.sticky-add-to-cart__price'); };
  var lastSrc = null;

  // Expo adds the lens to the price but may leave the "was" price alone. Never show a struck-through
  // price that is not higher than the price being charged.
  function amount(el) {
    el = el && (el.querySelector('bdi') || el);
    var n = el && el.textContent.replace(/[^0-9.]/g, '');
    return n ? parseFloat(n) : NaN;
  }
  function checkCompare(root) {
    if (!root) return;
    var was = root.querySelector('.compare-at-price');
    var now = root.querySelector('.price');
    if (!was || !now) return;
    var hide = !(amount(was) > amount(now));
    if (was.hidden !== hide) was.hidden = hide;
  }

  // Sitewide sale (Theme settings > Heat sale): Horizon's price element, which Expo and colour
  // changes update, holds the full price. Show the discounted price from it.
  function money(sample, pence) {
    return sample.replace(/[0-9][0-9,]*(\.[0-9]+)?/, (pence / 100).toFixed(2));
  }
  function saleRecalc(wrap) {
    var src = wrap.querySelector('product-price[data-hx-sale]');
    var out = wrap.querySelector('[data-hx-sale-out] [ref="priceContainer"]');
    if (!src || !out) return null;
    var pct = parseFloat(src.getAttribute('data-hx-sale')) || 0;
    var nowEl = src.querySelector('.price bdi'), wasEl = src.querySelector('.compare-at-price bdi');
    if (!nowEl) return out;
    var full = Math.round(amount(nowEl) * 100);
    var was = full;
    var cmp = wasEl ? Math.round(amount(wasEl) * 100) : 0;
    if (cmp > was) was = cmp;
    var now = full - Math.round(full * pct / 100);
    var text = nowEl.textContent;
    var a = out.querySelector('.price bdi'), b = out.querySelector('.compare-at-price bdi');
    if (a && a.textContent !== money(text, now)) a.textContent = money(text, now);
    if (b && b.textContent !== money(text, was)) b.textContent = money(text, was);
    return out;
  }

  function copyPrice(src) {
    src = src || lastSrc || document.querySelector('[data-hx-sale-out] [ref="priceContainer"]') || document.querySelector('.hx-pdp-price__now [ref="priceContainer"]');
    var dest = sticky();
    if (!src || !dest) return;
    lastSrc = src;
    var html = src.innerHTML;
    if (dest.innerHTML !== html) dest.innerHTML = html;
    checkCompare(src);
    checkCompare(dest);
  }

  function watchPrice() {
    document.querySelectorAll('.hx-pdp-price').forEach(function (wrap) {
      new MutationObserver(function () {
        var src = saleRecalc(wrap) || wrap.querySelector('[ref="priceContainer"]');
        if (src) { checkCompare(src); copyPrice(src); }
      }).observe(wrap, { childList: true, subtree: true, characterData: true });
    });
    document.querySelectorAll('.hx-pdp-price').forEach(saleRecalc);
    // Horizon morphs the sticky bar on variant change, putting the base price back
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar) new MutationObserver(function () { copyPrice(); }).observe(bar, { childList: true, subtree: true, characterData: true });
    copyPrice();
  }

  function watchChat() {
    var root = document.documentElement;
    var buy = document.querySelector('.buy-buttons-block');
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    var buyOn = false;
    var update = function () {
      var stuck = bar && bar.getAttribute('data-stuck') === 'true';
      root.classList.toggle('hx-chat-off', buyOn || stuck);
    };
    if (buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { buyOn = es[0].isIntersecting; update(); }).observe(buy);
    }
    if (bar) new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    update();
  }

  function init() { watchPrice(); watchChat(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
